import { Container, Fade, Modal as MuiModal } from "@mui/material";

interface IProps {
  open: boolean;
  onClose: (event: Event) => void;
  children: React.ReactElement;
  size: "xs" | "sm" | "md" | "lg";
  keepMounted?: boolean;
}

export default function Modal({ open, onClose, children, size, keepMounted }: IProps) {
  return (
    <MuiModal open={open} onClose={onClose} sx={{ display: "grid", placeItems: "center" }} keepMounted>
      <Fade in={open}>
        <Container maxWidth={size}>{children}</Container>
      </Fade>
    </MuiModal>
  );
}
